module.exports = __webpack_public_path__ + "static/media/key-logo.befc6eb9.png";